module.exports = __webpack_public_path__ + "img/markets-c.78901c0c.svg";